import { render, staticRenderFns } from "./ModuleCreate.vue?vue&type=template&id=cbea1efc&"
import script from "./ModuleCreate.vue?vue&type=script&lang=js&"
export * from "./ModuleCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports